/*
  Fires a "nooria:cart-added" event on document after every successful /cart/add
  request (product form, quick add, bundle modals, app widgets), so features don't
  each have to hook their own buttons. Used by clarity-events.js (add_to_cart) and
  membership-modal.js (opens after an add to cart).
  Plain ES5: must run in old Android WebView / Facebook & Instagram in-app browsers.
*/
(function () {
  'use strict';
  if (window.__nooriaCartEvents) return;
  window.__nooriaCartEvents = true;

  function isCartAdd(url) {
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0]);
  }

  function fire() {
    var event;
    try {
      event = new CustomEvent('nooria:cart-added');
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('nooria:cart-added', false, false, null);
    }
    document.dispatchEvent(event);
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var request = originalFetch.apply(this, arguments);
      if (isCartAdd(url)) {
        request.then(function (res) {
          if (res && res.ok) fire();
        }, function () {});
      }
      return request;
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartAdd(String(url))) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) fire();
        });
      }
      return originalOpen.apply(this, arguments);
    };
  }
})();
